import apiClient from '@/services/axios'

const getAll = async () => {
  const res = await apiClient.get('/news')
  if (res) {
    return res.data
  } else {
    return []
  }
}

const getById = async (id) => {
  const res = await apiClient.get(`/news/${id}`)
  if (res) {
    return res.data
  } else {
    return null
  }
}

const getTotalViews = async (newsId, months) => {
  const res = await apiClient.get(
    `/articleTotalViews/count?newsId=${newsId}&months=${months}`,
  )
  if (res) {
    return res.data
  } else {
    return null
  }
}

const deleteById = async (id) => {
  const res = await apiClient.delete(`/news/${id}`)
  if (res) {
    return res.data
  } else {
    return null
  }
}

const create = async (data) => {
  const res = await apiClient.post('/news', data, {})
  if (res) {
    return res
  } else {
    return null
  }
}

const editById = async (id, data) => {
  const res = await apiClient.patch(`/news/${id}`, data, {})
  if (res) {
    return res
  } else {
    return null
  }
}

export { getAll, getById, deleteById, create, editById, getTotalViews }
